import { render, staticRenderFns } from "./Paihuofeedback.vue?vue&type=template&id=58fdd74a&scoped=true&"
import script from "./Paihuofeedback.vue?vue&type=script&lang=js&"
export * from "./Paihuofeedback.vue?vue&type=script&lang=js&"
import style0 from "./Paihuofeedback.vue?vue&type=style&index=0&id=58fdd74a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fdd74a",
  null
  
)

export default component.exports